import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    isLoaded: false,
    adTrees: []
  }
};
const activeDocumentsSlice = createSlice({
  name: "activeDocumentsInfo",
  initialState,
  reducers: {
    loadActiveADTrees: (state, action) => {
      state.value = {
        isLoaded: true,
        adTrees: action.payload
      };
    }
  }
});
export const { loadActiveADTrees } = activeDocumentsSlice.actions;
export default activeDocumentsSlice.reducer;
